module.exports = __webpack_public_path__ + "media/audio5.cde7f75f.wav";